import styles from './styles.module.scss';
import Form from "@/components/Shared/Form";

export default function SimpleForm({
    customClass = "",
    formId,
    successPageUrl,
}) {

    return (
        <>
            <div className={`${styles.root} ${customClass}`}>
                {formId ?
                    <Form
                        formId={formId}
                        onSubmitDone={() => (window.location.href = successPageUrl)}
                    /> : ""}
            </div>
        </>
    )
}